import { takeEvery, put, fork } from 'redux-saga/effects'
import { customerServerUrl, customerCommandServerUrl, backofficeCommandURL, backofficeQueryURL, newCustomerCommandServerUrl } from '../../../../shared/config'
import { get, post } from '../../utils/ajax'
import { FETCH_API_KEYS, FETCH_SUBTREES, REQUEST_API_KEY, FORCE_EXPIRE_API_KEY, FETCH_ORGANISATION_NAME, AUTHENTICATED_USER_FETCHED, ADD_CHILD_NODE, REMOVE_CHILD_NODE, ADD_USER_TO_CHILD_NODE, GET_USERS_FROM_NODE, UPDATE_PRIVILEGE_TO_USER, UPDATE_USER_PRIVILEGE, ADD_VEHICLE_TO_CHILD_NODE, REMOVE_USER_FROM_CHILD_NODE, MODIFY_VEHICLE_TO_CHILD_NODE, MOVE_USER_TO_CHILD_NODE, EDIT_CHILD_NODE, GET_ALL_USERS_FROM_ORGANISATION, GET_ALL_VEHICLES_FROM_ORGANISATION, FETCH_ORGANISATION_TOOL_CONFIG } from '../types/customer'
import { childNodeAdded, childNodeEdited, childNodeRemoved, childNodeUserRemoved, expiredApiKeyByForce, fetchedApiKeys, fetchedOrganisationName, fetchedOrganisationNodeUsers, fetchedOrganisationToolConfig, fetchedUsersFromOrganisation, fetchedVehiclesFromOrganisation, fetchOrganisationName, receivedNewApiKey, subtreesFetched, updatedPrivilegeToUser, updatePrivilegeToUser, userHasBeenAdded, userHasBeenMoved, vehicleTochildNodeAdded, VehicleTochildNodeRemoved } from '../actions/customer'


function* fetchTreeNames(accessToken, tree) {
  yield put(fetchOrganisationName(accessToken, tree.uuid))
  /*if (tree.children?.length)
    for (const subtree of tree.children)
      yield fetchTreeNames(accessToken, subtree)*/
}

function* getSubTreesFromServer(options) {
  const shouldIgnoreSelectedOrgs = true

  const url = customerServerUrl() + '/customer/tags/subtrees'
  const result = yield get(options.token ?? options.accessToken, url, shouldIgnoreSelectedOrgs)
  if (result && result.status === 'ok') {
    const subtrees = yield result.data
    yield put(subtreesFetched(subtrees))
    for (const tree of subtrees)
      yield fetchTreeNames(options.token ?? options.accessToken, tree)
  }
}

function* getOrganisationNameFromServer(options) {
  const shouldIgnoreSelectedOrgs = true

  const url = customerServerUrl() + '/customer/tags/uuid/translate/' + options.id
  const result = yield get(options.accessToken, url, shouldIgnoreSelectedOrgs)
  if (result && result.status === 'ok')
    yield put(fetchedOrganisationName(yield result.data))
}

function* getApiKeysFromServer(options) {
  let url = customerServerUrl() + '/api'
  url = options.includeExpired ? url + '?expired=true' : url
  const result = yield get(options.accessToken, url)
  if (result && result.status === 'ok') {
    yield put(fetchedApiKeys(yield result.data?.keys, yield result.data?.total))
  }
  else if (result?.status === 'no_content')
    yield put(fetchedApiKeys([], 0))
}

function* requestApiKeyFromServer(options) {
  const url = customerCommandServerUrl() + '/cmd/api/requestkey'
  const body = {
    expiresAt: options.expiresAt ?? null,
    organisations: options.organisations ?? null
  }
  const result = yield post(options.accessToken, url, body)
  if (result && result.status === 'ok') {
    const data = yield result.data
    yield put(receivedNewApiKey({
      public_id: data.public_id.value, 
      expires_at_utc: data.expires_at_utc,
      api_key: data.api_key
    }))
  }
}

function* removeApiKeyFromServer(options) {
  const url = customerCommandServerUrl() + '/cmd/api/removekey'
  const body = {
    id: options.id
  }
  const result = yield post(options.accessToken, url, body)
  if (result && result.status === 'ok')
    yield put(expiredApiKeyByForce(options.id))
}

function* addChildNodeToOrganisation(options) {
  const url = backofficeCommandURL() + '/cmd/customer/addorganisation'
  const body = {
    parentId: options.parentId,
    name: options.name
  }
  const result = yield post(options.token, url, body)
  if(result && result.status === 'ok') {
    yield put(childNodeAdded(result.data.uuid, result.data.name, options.parentId))
  }else {
    yield put({ type: 'ADDING_CHILD_NODE_FAILED' })
  }
}



function* removeChildNodeFromOrganisation(options) {
  const url = backofficeCommandURL() + '/cmd/customer/removeorganisation'
  const body = {
    id: 'organisation/' + options.id,
  }
  const result = yield post(options.token, url, body)
  if(result && result.status === 'ok') {
    yield put(childNodeRemoved(options.id))
  }
}

function* editChildNodeFromOrganisation(options) {
  const url = backofficeCommandURL() + '/cmd/customer/renameorganisation'
  const body = {
    id: 'organisation/' + options.id,
    newName: options.newName
  }
  const result = yield post(options.token, url, body)
  if(result && result.status === 'ok') {
    yield put(childNodeEdited(options.id, options.newName))
  }
}


function* addUserToOrganisation(options) {
  const url = backofficeQueryURL() + '/user/v2/createuser'
  const userPrivilege = options.privilege ?? 'standard'
  const body = {
    user_metadata: {
      info: {
        tags: [{
          tags: options.id,
          privilege: userPrivilege
        }]
      }
    },
    firstName: options.firstName,
    lastName: options.lastName,
    email: options.email
  }

  const result = yield post(options.token, url, body)
  if(result?.status === 'ok') {
    yield put(userHasBeenAdded(options.id, options.firstName, options.lastName, options.email, userPrivilege))
  } 
  else if (result?.status === 'not_modified') {
    yield put({ type: 'USER_ALREADY_EXISTS_IN_NODE' })
  }
  else {
    yield put({ type: 'ADD_USER_TO_CHILD_NODE_FAILED' })
  }
}

function* removeUserFromOrganisation(options) {
  const url = backofficeQueryURL() + '/user/v2/remove-from-group'
  const body = {
    email: options.email,
    child: {
      tags: options.organisation,
      privilege: 'standard'
    }
  }

  const result = yield post(options.token, url, body)
  if(result?.status === 'ok') {
    yield put(childNodeUserRemoved(options.email, options.organisation))
  } 
  else {
    yield put({ type: 'REMOVE_USER_TO_CHILD_NODE_FAILED', payload: result.data })
  }
}

function* getUsersFromNode(options) {
  const url = customerServerUrl() + '/customer/node/' + options.uuid
  const result = yield get(options.token, url, true)
  if (result && result.status === 'ok') {
    const users = result.data.map(u => {
      return{
        id: u.id,
        firstName: u.firstName,
        lastName: u.lastName,
        email: u.email,
        privilege: u.privilege
      }
    })
    yield put(fetchedOrganisationNodeUsers(options.uuid, users))
  }
  else if (result?.status === 'no_content')
    yield put(fetchedOrganisationNodeUsers(options.uuid, []))
}


function* updateUserPrivilege(options) {
  const url = backofficeQueryURL() + '/user/v2/update-privileges'
  const body = {
    email: options.email,
    privileges: [{
      tags: options.tags,
      privilege: options.privilege
    }]
  }
  const result = yield post(options.token, url, body)
  if(result && result.status === 'ok') {
    yield put(updatedPrivilegeToUser(options.id, options.privilege, options.email))
  }
  else {
    yield put({ type: 'UPDATE_PRIVILEGE_FAILED' })
  }
}


function* modifyVehicleToOrganisation(options) {
  const subUrl = options.shouldRemove ? '/cmd/box/removefromcustomer' : '/cmd/box/connecttocustomer'
  const url = backofficeCommandURL() + subUrl
  const body = {
    id: 'vehicle/' + options.id,
    organisations: [
      options.organisation
    ]
  }

  const result = yield post(options.token, url, body)
  if(result && result.status === 'ok') {
    if (options.shouldRemove) 
      yield put(VehicleTochildNodeRemoved(options.id, options.organisation))
    else 
      yield put(vehicleTochildNodeAdded(options.id, options.vehicleName, options.model, options.year, options.licenseNumber, options.organisation))
  }
  else { 
    const message = options.shouldRemove ? 'REMOVE_VEHICLE_TO_CHILD_NODE_FAILED' : 'ADD_VEHICLE_TO_CHILD_NODE_FAILED'
    yield put({ type: message })
  }
}

function* moveUserToOrganisation(options) {
  const url = backofficeQueryURL() + '/user/v2/assign-to-group'
  const userPrivilege = options.privilege ?? 'standard'
  const body = {
    email: options.email,
    child: {
      tags: options.uuid,
      privilege: userPrivilege
    }
  }

  const result = yield post(options.token, url, body)
  
  if(result?.status === 'ok') {

    yield put(userHasBeenMoved(options.name, options.email, options.uuid, userPrivilege))
  } 
  else if (result?.status === 'not_modified') {
    yield put({ type: 'USER_ALREADY_EXISTS_IN_NODE' })
  }
  else {
    yield put({ type: 'MOVE_USER_TO_CHILD_NODE_FAILED',  payload: { name: options.name, email: options.email, error: result?.data?.message, code: result.data.code } })
  }
}

function* getAllUsersFromOrganisation(options) {
  const url = customerServerUrl() + `/customer/user/all-users?uuid=${options.orgId}`
  const result = yield get(options.token, url, true)


  if (result && result.status === 'ok') {
    const { users, total } = result.data
    yield put(fetchedUsersFromOrganisation(options.orgId, users, total))
  }
  else (result?.status === 'no_content') 
  yield put({ type: 'FETCHED_USERS_FROM_ORGANISATION_FAILED', payload: result.data })
}

function* getAllVehiclesFromOrganisation(options) {
  const url = customerServerUrl() + `/telematics/all-vehicles-v2?uuid=${options.orgId}`
  const result = yield get(options.token, url, true)


  if (result && result.status === 'ok') {
    const { vehicles, total } = result.data
    yield put(fetchedVehiclesFromOrganisation(options.orgId, vehicles, total))
  }
  else {
    yield put({ type: 'FETCHED_VEHICLES_FROM_ORGANISATION_FAILED', payload: result.data })
  }
}

function* getOrganisationToolConfiguration(options) {
  const url = customerServerUrl() + `/organisation/tool/configuration/${options.orgId}`
  const result = yield get(options.token, url, true)
 
  if (result && result.status === 'ok') {
    yield put(fetchedOrganisationToolConfig(options.orgId, result.data))
  } else {
    yield put({ type: 'FETCHED_ORGANISATION_TOOL_CONFIG_FAILED', payload: result.data })
  }
}

const COMMAND_MAP = {
  ADD_TOOL_CATEGORIES: { path: '/category/add-categories', keys: ['categories'] },
  ADD_TOOL_CATEGORY: { path: '/category/add', keys: ['category', 'iconUrl'] },
  ADD_TOOL_BRAND: { path: '/brand/add', keys: ['brand'] },
  ADD_TOOL_EQUIPMENT_NAME: { path: '/equipment-name/add', keys: ['equipmentName'] }, 
  
  REMOVE_TOOL_CATEGORY: { path: '/category/remove', keys: ['category', 'iconUrl'] },
  REMOVE_TOOL_BRAND: { path: '/brand/remove', keys: ['brand'] },
  REMOVE_TOOL_EQUIPMENT_NAME: { path: '/equipment-name/remove', keys: ['equipmentName'] },
  
  EDIT_TOOL_CATEGORY: { path: '/category/edit', keys: ['oldCategory', 'newCategory', 'oldIconUrl', 'newIconUrl'] },
  EDIT_TOOL_BRAND: { path: '/brand/edit', keys: ['oldBrand', 'newBrand'] },
  EDIT_TOOL_EQUIPMENT_NAME: { path: '/equipment-name/edit', keys: ['oldEquipmentName', 'newEquipmentName'] },
  
  TOGGLE_CUSTOM_CATEGORIES: { path: '/toggle-custom-categories', keys: ['isEnabled'] },
  TOGGLE_CUSTOM_BRANDS: { path: '/toggle-custom-brands', keys: ['isEnabled'] },
  TOGGLE_CUSTOM_EQUIPMENT_NAMES: { path: '/toggle-custom-equipment-names', keys: ['isEnabled'] }
}

function* toolConfigurationCommands(options) {
  const config = COMMAND_MAP[options.type]

  if (!config) return 

  const url = `${newCustomerCommandServerUrl()}/cmd/organisation/tools${config.path}`
  
  const body = { organisationId: options.orgId }
  config.keys.forEach(key => {
    body[key] = options[key]
  })

  const result = yield post(options.token, url, body)

  if (result && result.status !== 'ok') {
    yield put({ type: `${options.type}_FAILED`, payload: body })
  }
}

export function* customerSagas() {
  yield takeEvery(FETCH_SUBTREES, getSubTreesFromServer)
  yield takeEvery(AUTHENTICATED_USER_FETCHED, getSubTreesFromServer)
  yield takeEvery(FETCH_ORGANISATION_NAME, getOrganisationNameFromServer)
  yield takeEvery(FETCH_API_KEYS, getApiKeysFromServer)
  yield takeEvery(REQUEST_API_KEY, requestApiKeyFromServer)
  yield takeEvery(FORCE_EXPIRE_API_KEY, removeApiKeyFromServer)
  yield takeEvery(ADD_CHILD_NODE, addChildNodeToOrganisation)
  yield takeEvery(REMOVE_CHILD_NODE, removeChildNodeFromOrganisation)
  yield takeEvery(EDIT_CHILD_NODE, editChildNodeFromOrganisation)
  yield takeEvery(ADD_USER_TO_CHILD_NODE, addUserToOrganisation)
  yield takeEvery(REMOVE_USER_FROM_CHILD_NODE, removeUserFromOrganisation)
  yield takeEvery(GET_USERS_FROM_NODE, getUsersFromNode)
  yield takeEvery(UPDATE_USER_PRIVILEGE, updateUserPrivilege)
  yield takeEvery(MODIFY_VEHICLE_TO_CHILD_NODE, modifyVehicleToOrganisation)
  yield takeEvery(MOVE_USER_TO_CHILD_NODE, moveUserToOrganisation)
  yield takeEvery(GET_ALL_USERS_FROM_ORGANISATION, getAllUsersFromOrganisation)
  yield takeEvery(GET_ALL_VEHICLES_FROM_ORGANISATION, getAllVehiclesFromOrganisation)
  yield takeEvery(FETCH_ORGANISATION_TOOL_CONFIG, getOrganisationToolConfiguration)
  yield takeEvery('ADD_TOOL_CATEGORIES', toolConfigurationCommands)
  yield takeEvery('ADD_TOOL_CATEGORY', toolConfigurationCommands)
  yield takeEvery('ADD_TOOL_BRAND', toolConfigurationCommands)
  yield takeEvery('ADD_TOOL_EQUIPMENT_NAME', toolConfigurationCommands)
  yield takeEvery('REMOVE_TOOL_CATEGORY', toolConfigurationCommands)
  yield takeEvery('REMOVE_TOOL_BRAND', toolConfigurationCommands)
  yield takeEvery('REMOVE_TOOL_EQUIPMENT_NAME', toolConfigurationCommands)
  yield takeEvery('EDIT_TOOL_CATEGORY', toolConfigurationCommands)
  yield takeEvery('EDIT_TOOL_BRAND', toolConfigurationCommands)
  yield takeEvery('EDIT_TOOL_EQUIPMENT_NAME', toolConfigurationCommands)
  yield takeEvery('TOGGLE_CUSTOM_CATEGORIES', toolConfigurationCommands)
  yield takeEvery('TOGGLE_CUSTOM_BRANDS', toolConfigurationCommands)
  yield takeEvery('TOGGLE_CUSTOM_EQUIPMENT_NAMES', toolConfigurationCommands)
}